import { create } from 'zustand';

interface ImpersonationSession {
  sessionId: string;
  adminId: string;
  impersonatedUserId: string;
  impersonatedUserEmail: string;
  startedAt: string;
  reason: string;
  isActive: boolean;
}

interface ImpersonationStore {
  session: ImpersonationSession | null;
  setSession: (session: ImpersonationSession | null) => void;
  clearSession: () => void;
}

export const useImpersonationStore = create<ImpersonationStore>((set) => {
  // Initialize from localStorage if available
  const loadFromStorage = (): ImpersonationSession | null => {
    if (typeof window === 'undefined') return null;
    try {
      const stored = localStorage.getItem('impersonation_session');
      if (stored) {
        return JSON.parse(stored);
      }
    } catch (err) {
      console.error('[ImpersonationStore] Failed to load from localStorage:', err);
    }
    return null;
  };

  const initialSession = loadFromStorage();

  return {
    session: initialSession,
    setSession: (session) => {
      set({ session });
      if (session && typeof window !== 'undefined') {
        localStorage.setItem('impersonation_session', JSON.stringify(session));
      } else if (typeof window !== 'undefined') {
        localStorage.removeItem('impersonation_session');
      }
    },
    clearSession: () => {
      set({ session: null });
      if (typeof window !== 'undefined') {
        localStorage.removeItem('impersonation_session');
      }
    },
  };
});

// Convenience hooks
export const useImpersonationSession = () => useImpersonationStore((state) => state.session);
export const useEndImpersonation = () => useImpersonationStore((state) => state.clearSession);
export const useStartImpersonation = () => useImpersonationStore((state) => state.setSession);

